import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Bolsa } from '../models/bolsa.model';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BolsaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  // List all bolsas
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: Bolsa[] }>(
        `${this.path}/getAllBolsa`,
        params
          ? new HttpParams({
            fromObject: params,
          })
          : this.params
      )
      .pipe(
        // debounceTime(500),
        map((response) => response)
      );
  }

  // Create new bolsa
  public store(form: Bolsa): Observable<any> {
    const bolsa = form;
    return this.apiService
      .post<{ object: Bolsa }>(`${this.path}/AddBolsa`, bolsa)
      .pipe(map((response) => response));
  }

  // Update existing bolsa
  public update(form: any, id: string): Observable<any> {
    return this.apiService
      .put<{ object: Bolsa }>(`${this.path}/UpdateBolsa/${id}`, form)
      .pipe(map((response) => response));
  }

  public updateBolsaCompleta(formData: any, id: string): Observable<any> {
    return this.apiService.put(`${this.path}/UpdateBolsaCompleta`, formData);
  }

  public toggleStatus(id: string): Observable<boolean> {
    return this.apiService
      .patch<{ data: boolean }>(`${this.path}/ToogleBolsaStatus/${id}`, {})
      .pipe(map((response) => response.data));
  }

  atualizarEstado(id: number, estadoBolsa: number, observacao?: string): Observable<any> {
    return this.apiService
      .put<any>(`${this.path}/AtualizarEstadoBolsa/${id}/${estadoBolsa}`, { observacao })
      .pipe(map((response) => response));
  }

  // Delete existing bolsa
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteBolsaById/${id}`);
  }

  updateEstudante(id: string, form: Bolsa): Observable<any> {
    return this.apiService
      .put<{ object: Bolsa }>(`${this.path}/UpdateEstudante/${id}`, form)
      .pipe(map((response) => response));
  }

  // Get bolsa by ID
  public show(id: string): any {
    return this.apiService
      .get<{ object: Bolsa }>(`${this.path}/getBolsaById/${id}`)
      .pipe(map((response) => response));
  }

  exportComprovativo(id: number): Observable<any> {
    return this.apiService
      .download(`${this.path}/GerarComprovativo/${id}`)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  exportComprovativoSubsidio(data: any): Observable<any> {
    return this.apiService
      .post(`${this.path}/PAGAMENTO_DE_SUBSIDIO_APOIO_FORMACAO`, data, {
        responseType: 'blob',
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  gerarFichaCadastro(body: any): Observable<any> {
    return this.apiService.post<any>(`${this.path}/FichaCadastro`, body, {
      responseType: 'blob' as 'json',
    });
  }

  exportMemorandoPagamentoSubsidioExterno(data: any): Observable<any> {
    return this.apiService
      .post(`${this.path}/Memorando-Pagamento-subsidio`, data, {
        responseType: 'blob',
      })
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  verificarRegraPagamento(payload: any): Observable<any> {
    return this.apiService
      .post(`${this.path}/VerificarRegraPagamento`, payload)
      .pipe(map((response: any) => response));
  }

  public verificarRegraPagamentoEstudanteDocumento(
    VerificarRegraPagamentoEstudanteDocumentoRequest: any
  ): Observable<any> {
    const bolsa = VerificarRegraPagamentoEstudanteDocumentoRequest;
    return this.apiService
      .post<{ object: Bolsa }>(
        `${this.path}/VerificarRegraPagamentoEstudanteDocumento`,
        bolsa
      )
      .pipe(map((response) => response));
  }
}
